<template>
  <video class="col-span-6 w-full" controls>
    <source :src="video[0].url" :type="video[0].contentType" />
  </video>
</template>

<script>
export default {
  name: "ContentVideo",

  props: {
    video: {
      type: Array,
      default: () => []
    }
  }
};
</script>
